var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "bg-gray2 py-1" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c(
              "div",
              { staticClass: "d-flex justify-content-between align-items-end" },
              [
                _c("ob1-breadcrumb", {
                  staticClass: "me-2 breadcrumb-full",
                  staticStyle: { "min-width": "0" },
                  attrs: { items: _vm.breadcrumbItems },
                }),
                _vm._v(" "),
                _vm.dto.digitalCartTooltipDto
                  ? _c("div", [
                      _c("div", { staticClass: "row justify-content-end" }, [
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c("digital-cart-tooltip", {
                              attrs: {
                                title: _vm.dto.digitalCartTooltipDto.title,
                                content: _vm.dto.digitalCartTooltipDto.content,
                                "cta-label":
                                  _vm.dto.digitalCartTooltipDto.ctaLabel,
                                "cta-url":
                                  _vm.dto.digitalCartTooltipDto.cartPageUrl,
                                "empty-cart":
                                  _vm.dto.digitalCartTooltipDto.emptyCart,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.dto.selectedOffer && !_vm.dto.selectedOffer.fromCart
              ? _c("selected-offer", {
                  staticClass: "mt-2 mb-1 d-webview-none",
                  attrs: {
                    title: _vm.dto.selectedOffer.title,
                    "continue-without-mobile":
                      _vm.dto.selectedOffer.continueWithoutMobile,
                    "modify-mobile-label":
                      _vm.dto.selectedOffer.modifyMobileLabel,
                    "modify-offer": _vm.dto.selectedOffer.modifyOffer,
                    "offer-label": _vm.dto.selectedOffer.offerLabel,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-webview-none" },
              [
                _vm.dto.contractInfos
                  ? _c("contract-phone-lines", {
                      staticClass: "mb-md-1 my-lg-1",
                      attrs: { "contract-infos": _vm.dto.contractInfos },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.dto.incentiveDto
              ? _c("incentive", {
                  attrs: {
                    title: _vm.dto.incentiveDto.question,
                    text: _vm.dto.incentiveDto.message,
                    "link-href": _vm.dto.changerMobileLink,
                    "link-label": _vm.dto.incentiveDto.linkLabel,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.dto.intentionSwitchDto
              ? _c("intention-switch", {
                  attrs: {
                    "shop-sosh": _vm.isBrandSosh,
                    title: _vm.dto.intentionSwitchDto.title,
                    "acquisition-label": _vm.currentVersion.firstParty
                      ? _vm.dto.intentionSwitchDto.acquisitionLabel
                      : null,
                    "tseul-label": _vm.dto.intentionSwitchDto.tseulLabel,
                    "changer-de-mobile-label":
                      _vm.dto.intentionSwitchDto.changerDeMobileLabel,
                    "default-intention-checked": _vm.intentionParam,
                    "linked-with-results": true,
                  },
                  on: {
                    "switch-intention": function ($event) {
                      return _vm.switchIntention($event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.dto.customerPopin
              ? [
                  _c("customer-popin", {
                    attrs: {
                      id: "customer-popin-id",
                      title: _vm.dto.customerPopin.customerPopinLabelsDto.title,
                      subtitle:
                        _vm.dto.customerPopin.customerPopinLabelsDto.subtitle,
                      text: _vm.dto.customerPopin.customerPopinLabelsDto.text,
                      "button-label":
                        _vm.dto.customerPopin.customerPopinLabelsDto
                          .buttonLabel,
                      "button-link":
                        _vm.dto.customerPopin.customerPopinLinksDto.buttonLink,
                      "link-label-html":
                        _vm.dto.customerPopin.customerPopinLabelsDto
                          .linkLabelHtml,
                      link: _vm.dto.customerPopin.customerPopinLinksDto.link,
                      intention: _vm.dto.customerPopin.intention,
                    },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column flex-md-row mb-1 header" },
              [
                _c("h1", { staticClass: "mb-0 me-md-1" }, [
                  _vm.bannerAndBrand
                    ? _c("span", { staticClass: "h3 fw-normal" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.bannerAndBrand)
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("strong", [_vm._v(_vm._s(_vm.currentVersion.name))]),
                ]),
                _vm._v(" "),
                _vm.displayRatings
                  ? _c("Rating", {
                      staticClass: "item-summary mb-md-1 m-0",
                      attrs: {
                        average: _vm.currentVersion.reviewsStats.average,
                        text:
                          "(" +
                          _vm.currentVersion.reviewsStats.count +
                          " avis)",
                        "rating-results-height": 1.375,
                        link: "#anchor-reviews",
                      },
                      on: {
                        "ob1-rating-link": function ($event) {
                          $event.preventDefault()
                          return _vm.scrollToPageMenuAnchor("anchor-reviews")
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex flex-column flex-md-row bg-white" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column info-device-width border-right-md border-gray2",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "px-1 px-lg-2 py-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "item-img" },
                          [
                            _c("ob1-carrousel", {
                              key: "device-gallery-" + _vm.currentVersion.seoId,
                              attrs: {
                                id: "device-gallery",
                                images: _vm.currentVersion.images,
                                "is-product-sheet": true,
                                "is-device-product-sheet": true,
                                "with-zoom": true,
                                "with-thumbnails": true,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.currentDetailsForIntention.asilage
                          ? _c("ob1-separateur", { staticClass: "my-1" })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentDetailsForIntention.asilage
                          ? _c("asilage", {
                              attrs: {
                                title:
                                  _vm.currentDetailsForIntention.asilage.title,
                                condition:
                                  _vm.currentDetailsForIntention.asilage
                                    .condition,
                                "form-url":
                                  _vm.currentDetailsForIntention.asilage
                                    .formUrl,
                                image:
                                  _vm.currentDetailsForIntention.asilage.image,
                                "condition-label":
                                  _vm.currentDetailsForIntention.asilage
                                    .conditionLabel,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "w-100" }, [
                  _c(
                    "div",
                    { staticClass: "px-1 px-md-2 py-1" },
                    [
                      _c(
                        "fieldset",
                        [
                          _c("legend", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                                Couleur\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("ColorChips", {
                            staticClass: "mb-2",
                            attrs: {
                              id: "colors",
                              "selected-color": _vm.currentVersion.color
                                ? _vm.currentVersion.color.code
                                : null,
                              colors: _vm.allColors,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeVariant("color", $event.code)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.dto.allVariants, function (variant, index) {
                        return _c(
                          "fieldset",
                          {
                            key: "variant-" + index,
                            class: { "mt-1": !_vm.numberOfColors },
                          },
                          [
                            _c("legend", { staticClass: "visually-hidden" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(variant.name) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              variant.values,
                              function (value, valueIndex) {
                                return _c("ob1-chips", {
                                  key: "variant-" + index + "-" + valueIndex,
                                  attrs: {
                                    id: "variant-" + index + "-" + valueIndex,
                                    "is-choice-version": true,
                                    label: value,
                                    "is-disabled":
                                      _vm.allGrades.length === 0 &&
                                      index ===
                                        _vm.dto.allVariants.length - 1 &&
                                      !_vm.hasVariantEnabled(
                                        variant.name,
                                        value
                                      ),
                                    "is-checked":
                                      _vm.hasCurrentVersionVariantChecked(
                                        variant.name,
                                        value
                                      ),
                                    "disable-uncheck": true,
                                    "additional-classes": "mb-1",
                                  },
                                  on: {
                                    "ob1-chips-click": function ($event) {
                                      return _vm.changeVariant(
                                        variant.name,
                                        value
                                      )
                                    },
                                  },
                                })
                              }
                            ),
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _vm.allGrades.length > 0
                        ? _c(
                            "fieldset",
                            { staticClass: "mt-1" },
                            [
                              _c("legend", { staticClass: "visually-hidden" }, [
                                _vm._v(
                                  "\n                                Etat du mobile Reconditionné\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.allGrades, function (grade, index) {
                                return _c("ob1-chips", {
                                  key: "grade-" + index,
                                  attrs: {
                                    id: "grade-" + index,
                                    "is-choice-version": true,
                                    label: grade.label,
                                    "is-disabled": false,
                                    "is-checked": grade.isChecked,
                                    "additional-classes": "mb-1",
                                    "disable-uncheck": true,
                                  },
                                  on: {
                                    "ob1-chips-click": function ($event) {
                                      return _vm.changeVariant(
                                        "grade",
                                        grade.label
                                      )
                                    },
                                  },
                                })
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allGrades.length > 0
                        ? [
                            _c("ob1-liens", {
                              attrs: {
                                text: "Pour en savoir plus, c'est par ici",
                                "is-button": "",
                                "data-bs-toggle": "modal",
                                "modal-id": "gradeModal",
                                "with-arrow": "",
                                "data-oevent-category":
                                  "comment_choisir_son_reconditionne",
                                "data-oevent-action": _vm.getGradePopinAction(),
                                "data-oevent-label": "vers_popin",
                              },
                            }),
                            _vm._v(" "),
                            _c("grade-popin", {
                              attrs: {
                                "modal-id": "gradeModal",
                                "default-grade-id": _vm.checkedGrade?.code,
                                labels: _vm.gradeLabels,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allBatteries.length > 0
                        ? _c(
                            "fieldset",
                            { staticClass: "mt-1" },
                            [
                              _c("legend", { staticClass: "visually-hidden" }, [
                                _vm._v(
                                  "\n                                Etat de la batterie\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.allBatteries,
                                function (battery, index) {
                                  return _c("ob1-chips", {
                                    key: "battery-" + index,
                                    attrs: {
                                      id: "battery-" + index,
                                      "is-choice-version": true,
                                      label: battery.label,
                                      "is-disabled": !_vm.hasVariantEnabled(
                                        "battery",
                                        battery.label
                                      ),
                                      "is-checked": battery.isChecked,
                                      "additional-classes": "mb-1",
                                      "disable-uncheck": true,
                                    },
                                    on: {
                                      "ob1-chips-click": function ($event) {
                                        return _vm.changeVariant(
                                          "battery",
                                          battery.label
                                        )
                                      },
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ob1-separateur", { staticClass: "my-1" }),
                      _vm._v(" "),
                      _vm.currentDetailsForIntention
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-lg-flex justify-content-between",
                              },
                              [
                                _c("device-detail-price", {
                                  attrs: {
                                    "device-price":
                                      _vm.currentDetailsForIntention.price,
                                    "is-price-inversion-enabled":
                                      _vm.dto.priceInversionEnabled,
                                    "loan-rate-zero-label":
                                      _vm.dto.loanRateZeroLabel,
                                    "loan-rate-zero-offer-label":
                                      _vm.dto.loanRateZeroOfferLabel,
                                    "funding-details": _vm.fundingDetails,
                                    "show-guarantee-legal-mentions":
                                      _vm.currentVersion
                                        .showGuaranteeLegalMentions,
                                    "guarantee-legal-mentions-label":
                                      _vm.currentVersion
                                        .guaranteeLegalMentionsLabel,
                                    commitment:
                                      _vm.currentDetailsForIntention.commitment,
                                    "complementary-price-label":
                                      _vm.currentDetailsForIntention
                                        .complementaryPriceLabel,
                                    "device-name": _vm.fundingDetailDeviceName,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.advantages
                              ? _c("refunds", {
                                  staticClass: "mb-1",
                                  attrs: {
                                    odrs: _vm.advantages.odrData,
                                    "device-seo-id": _vm.currentVersion.seoId,
                                    "refund-messages": _vm.dto.refundMessages,
                                    recovery: _vm.advantages.recovery,
                                    "total-amount-in-cents":
                                      _vm.advantages.totalAmountInCents,
                                    "advantages-label": _vm.advantages.label,
                                    "simulator-modal-id": _vm.simulatorModalId,
                                    "simulator-result-modal-id":
                                      _vm.savedSimulationResultModalId,
                                    "recovery-modal-id": _vm.recoveryModalId,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRecovery
                              ? [
                                  _c("mobile-recovery-simulator-modal", {
                                    attrs: {
                                      "modal-id": _vm.simulatorModalId,
                                      shop: _vm.shop,
                                      messages:
                                        _vm.dto.refundMessages
                                          .recoverySimulator,
                                    },
                                    on: {
                                      "update-recovery-simulation":
                                        _vm.updateRecoveryPrice,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.advantages.recovery.manualEstimation
                                    ? _c(
                                        "mobile-recovery-simulation-result-modal",
                                        {
                                          attrs: {
                                            "modal-id":
                                              _vm.savedSimulationResultModalId,
                                            shop: _vm.shop,
                                            messages:
                                              _vm.dto.refundMessages
                                                .recoverySimulator.result,
                                            "estimated-device-price-in-cents":
                                              _vm.advantages.recovery
                                                .amountInCents,
                                            "estimated-device-model":
                                              _vm.advantages.recovery
                                                .deviceModel,
                                            bonus:
                                              _vm.advantages.recovery.bonus,
                                            "online-recovery-available":
                                              _vm.onlineRecoveryAvailable,
                                          },
                                          on: {
                                            "new-simulation": _vm.newSimulation,
                                            "save-simulation":
                                              _vm.saveSimulation,
                                          },
                                        }
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "mobile-recovery-simulation-result-modal",
                                    {
                                      attrs: {
                                        "modal-id":
                                          _vm.currentSimulationResultModalId,
                                        shop: _vm.shop,
                                        messages:
                                          _vm.dto.refundMessages
                                            .recoverySimulator.result,
                                        "estimated-device-price-in-cents":
                                          _vm.estimatedDevice
                                            .recoveryPriceInCents,
                                        "estimated-device-model":
                                          _vm.estimatedDevice.model,
                                        bonus: _vm.advantages.recovery.bonus,
                                        "online-recovery-available":
                                          _vm.onlineRecoveryAvailable,
                                      },
                                      on: {
                                        "new-simulation": _vm.newSimulation,
                                        "save-simulation": _vm.saveSimulation,
                                      },
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c("mobile-recovery-details-modal", {
                                    attrs: {
                                      "modal-id": _vm.recoveryModalId,
                                      "infos-recovery":
                                        _vm.dto.refundMessages.recoveryModal
                                          .infosRecovery,
                                      "online-recovery":
                                        _vm.onlineRecoveryAvailable
                                          ? _vm.dto.refundMessages.recoveryModal
                                              .onlineRecovery
                                          : null,
                                      "store-recovery": _vm.eligibleEresa
                                        ? _vm.dto.refundMessages.recoveryModal
                                            .storeRecovery
                                        : null,
                                      "bonus-recovery":
                                        _vm.dto.refundMessages.recoveryModal
                                          .bonusRecovery,
                                      bonus: _vm.advantages.recovery.bonus,
                                      "recovery-simulator":
                                        _vm.dto.refundMessages
                                          .recoverySimulator,
                                      "simulator-button-label":
                                        _vm.dto.refundMessages
                                          .simulatorButtonLabel,
                                      "bonus-amount": _vm.bonusAmountFormat,
                                      "simulator-modal-id":
                                        _vm.simulatorModalId,
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentDetailsForIntention.preorder
                              ? [_vm._m(0)]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isLoading
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-spinner d-flex justify-content-center",
                                  },
                                  [
                                    _c("ob1-progress-indicators", {
                                      attrs: { size: 50, type: "undetermined" },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentDetailsForIntention.chooseOfferLinks !=
                            null
                              ? [
                                  _c("Bouton", {
                                    ref: "add-device-cta",
                                    staticClass: "mt-1",
                                    attrs: {
                                      label: _vm.ctaLabel,
                                      "is-primary": true,
                                      "tms-category": _vm.needAuthentication
                                        ? "popin_poursuivre_votre_commande"
                                        : "fiche_produit",
                                      "tms-action": _vm.ctaLabel,
                                      "tms-label": _vm.needAuthentication
                                        ? null
                                        : _vm.currentDetailsForIntention
                                            .chooseOfferLinks.link,
                                      href: _vm.needAuthentication
                                        ? null
                                        : _vm.currentDetailsForIntention
                                            .chooseOfferLinks.link,
                                      "is-button": _vm.needAuthentication,
                                      "data-bs-toggle": _vm.needAuthentication
                                        ? "modal"
                                        : null,
                                      "data-bs-target": _vm.needAuthentication
                                        ? "#authenticationPopIn"
                                        : null,
                                    },
                                    on: { click: _vm.handleCtaClick },
                                  }),
                                  _vm._v(" "),
                                  _vm.dto.authenticationPopinLabelsDto
                                    ? _c("authentication-popin", {
                                        attrs: {
                                          id: "authenticationPopIn",
                                          title:
                                            _vm.dto.authenticationPopinLabelsDto
                                              .title,
                                          subtitle:
                                            _vm.dto.authenticationPopinLabelsDto
                                              .subtitle,
                                          "new-client-title":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .newClientTitle,
                                          "new-client-description":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .newClientDescription,
                                          "new-client-href":
                                            _vm.currentDetailsForIntention
                                              .chooseOfferLinks.link,
                                          "client-title":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .alreadyClientTitle,
                                          "client-description":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .alreadyClientDescription,
                                          "client-href":
                                            _vm.currentDetailsForIntention
                                              .chooseOfferLinks
                                              .authenticatedLink,
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              : _vm.currentDetailsForIntention.orderLinks !=
                                null
                              ? [
                                  _vm.dto.authenticationPopinLabelsDto &&
                                  _vm.currentDetailsForIntention.orderLinks
                                    .onlineAuthenticatedOrderHref
                                    ? _c("authentication-popin", {
                                        attrs: {
                                          id: "authenticationPopIn",
                                          title:
                                            _vm.dto.authenticationPopinLabelsDto
                                              .title,
                                          subtitle:
                                            _vm.dto.authenticationPopinLabelsDto
                                              .subtitle,
                                          "new-client-title":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .newClientTitle,
                                          "new-client-description":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .newClientDescription,
                                          "new-client-href":
                                            _vm.currentDetailsForIntention
                                              .orderLinks.onlineOrderHref,
                                          "client-title":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .alreadyClientTitle,
                                          "client-description":
                                            _vm.dto.authenticationPopinLabelsDto
                                              .alreadyClientDescription,
                                          "client-href":
                                            _vm.currentDetailsForIntention
                                              .orderLinks
                                              .onlineAuthenticatedOrderHref,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentDetailsForIntention.orderLinks
                                    .eresaOrderHref &&
                                  _vm.currentDetailsForIntention.orderLinks
                                    .onlineOrderHref
                                    ? [
                                        _c("Bouton", {
                                          ref: "add-device-cta",
                                          staticClass: "mt-1",
                                          attrs: {
                                            label: _vm.ctaLabel,
                                            "is-primary": true,
                                            "tms-category":
                                              "popin_poursuivre_votre_commande",
                                            "tms-action": _vm.ctaLabel,
                                            "tms-label": "",
                                            "is-button": "",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target":
                                              "#allDisponibilitiesPopIn",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("all-disponibilities-popin", {
                                          attrs: {
                                            id: "allDisponibilitiesPopIn",
                                            title:
                                              _vm.dto
                                                .allDisponibilitiesPopinLabelsDto
                                                .title,
                                            "tdc-section":
                                              _vm.dto
                                                .allDisponibilitiesPopinLabelsDto
                                                .tdcSection,
                                            "eresa-section":
                                              _vm.dto
                                                .allDisponibilitiesPopinLabelsDto
                                                .eresaSection,
                                            "eco-foot-note":
                                              _vm.dto
                                                .allDisponibilitiesPopinLabelsDto
                                                .ecoFootNote,
                                            "tdc-href": _vm.needAuthentication
                                              ? null
                                              : _vm.currentDetailsForIntention
                                                  .orderLinks.onlineOrderHref,
                                            "eresa-href":
                                              _vm.currentDetailsForIntention
                                                .orderLinks.eresaOrderHref,
                                            "chain-to-auth-on-online":
                                              _vm.needAuthentication,
                                          },
                                          on: {
                                            "online-click-requires-auth":
                                              _vm.openAuthenticationAfterDisponibilities,
                                          },
                                        }),
                                      ]
                                    : _vm.currentDetailsForIntention.orderLinks
                                        .eresaOrderHref
                                    ? [
                                        _c("Bouton", {
                                          ref: "add-device-cta",
                                          staticClass: "mt-1",
                                          attrs: {
                                            label: _vm.ctaLabel,
                                            "is-primary": true,
                                            "tms-category": "fiche_produit",
                                            "tms-action": _vm.ctaLabel,
                                            "tms-label":
                                              _vm.currentDetailsForIntention
                                                .orderLinks.eresaOrderHref,
                                            href: _vm.currentDetailsForIntention
                                              .orderLinks.eresaOrderHref,
                                            "is-button": false,
                                          },
                                          on: { click: _vm.handleCtaClick },
                                        }),
                                      ]
                                    : _vm.currentDetailsForIntention.orderLinks
                                        .onlineOrderHref
                                    ? [
                                        _c("Bouton", {
                                          ref: "add-device-cta",
                                          staticClass: "mt-1",
                                          attrs: {
                                            label: _vm.ctaLabel,
                                            "is-primary": true,
                                            "tms-category":
                                              _vm.needAuthentication
                                                ? "popin_poursuivre_votre_commande"
                                                : "fiche_produit",
                                            "tms-action": _vm.ctaLabel,
                                            "tms-label":
                                              _vm.currentDetailsForIntention
                                                .orderLinks.onlineOrderHref,
                                            href: _vm.needAuthentication
                                              ? null
                                              : _vm.currentDetailsForIntention
                                                  .orderLinks.onlineOrderHref,
                                            "is-button": _vm.needAuthentication,
                                            "data-bs-toggle":
                                              _vm.needAuthentication
                                                ? "modal"
                                                : null,
                                            "data-bs-target":
                                              _vm.needAuthentication
                                                ? "#authenticationPopIn"
                                                : null,
                                          },
                                          on: { click: _vm.handleCtaClick },
                                        }),
                                      ]
                                    : _vm._e(),
                                ]
                              : _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c("ob1-message-alerte", {
                                      staticClass: "col-12 pt-2",
                                      attrs: {
                                        "is-simple-alerte": false,
                                        title:
                                          _vm.dto.alertStatusMessages.title,
                                        text: _vm.dto.alertStatusMessages
                                          .message,
                                        type: "warning",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mt-2" },
                              [
                                _vm.dto.showSoldByInfos
                                  ? _c("sold-by-card", {
                                      attrs: {
                                        title: _vm.sellerLabel,
                                        "sold-by-orange":
                                          _vm.currentVersion.firstParty,
                                        "info-lines": _vm.deliveryLabel,
                                      },
                                    })
                                  : _vm._l(_vm.deliveryLabel, function (info) {
                                      return _c("availability-mention", {
                                        key: info.label,
                                        attrs: {
                                          available: info.status === "SUCCESS",
                                          label: info.label,
                                        },
                                      })
                                    }),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ]
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.shouldShowDasBatteryOrEnergyLabelBlock
        ? _c("div", { staticClass: "bg-gray2" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c(
                "div",
                { staticClass: "row align-items-center pb-1" },
                [
                  _vm.currentVersion.das
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-md-auto" },
                        [
                          _c("das", {
                            staticClass: "my-1",
                            attrs: {
                              head: _vm.currentVersion.das.head,
                              trunk: _vm.currentVersion.das.trunk,
                              member: _vm.currentVersion.das.member,
                              prefix: _vm.currentVersion.das.prefix,
                              "popin-title": _vm.currentVersion.das.popinTitle,
                              "popin-text":
                                _vm.currentVersion.das.popinDescription,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVersion.chargerInfos
                    ? [
                        _vm.currentVersion.chargerInfos.chargerIncluded
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "icon icon-charger-availability charger-icon-size ps-1 ps-md-0 text-gray4",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                    _vm._v(" "),
                                    _c("strong", {
                                      staticClass: "ps-3 ps-md-0",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.currentVersion.chargerInfos
                                            .chargerIncludedMessage
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm.currentVersion.chargerInfos
                              .chargerCompatibleInfos
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md-auto my-1 my-md-0 mx-md-2 px-md-0",
                              },
                              [
                                _c("ChargerInfos", {
                                  attrs: {
                                    "charger-infos":
                                      _vm.currentVersion.chargerInfos
                                        .chargerCompatibleInfos,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentVersion.energyLabel
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-md-auto" },
                        [
                          _c("energy-label", {
                            attrs: {
                              id: _vm.currentVersion.seoId,
                              "energy-label": _vm.currentVersion.energyLabel,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldDisplayPXFMention
        ? _c(
            "section",
            { staticClass: "container-fluid" },
            [
              _c("pxf-description", {
                attrs: { "pxf-legal-mentions-text": _vm.dto.pxfMention },
              }),
              _vm._v(" "),
              _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-2 mb-1" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("financing-mentions", {
                      attrs: {
                        "financing-mentions": _vm.dto.financingMentions,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("ob1-separateur", { staticClass: "my-2 mb-1" }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid mt-2" },
        [
          _vm.currentVersion.descriptionTitle
            ? _c("p", { staticClass: "lead text-mw mb-0" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.currentVersion.descriptionTitle)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.description
            ? _c("p", {
                staticClass: "text-mw",
                domProps: { innerHTML: _vm._s(_vm.currentVersion.description) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageMenu.tabs.length > 0
            ? _c("ob1-page-menu", {
                staticClass: "sticky bg-white mb-2",
                attrs: { id: "device-details-page-menu", tabs: _vm.tabs },
                on: { "ob1-page-menu-click": _vm.scrollToPageMenuAnchor },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.zigZag || _vm.currentVersion.longDescription
            ? _c(
                "section",
                [
                  _c("div", { staticClass: "mb-xl-3" }),
                  _vm._v(" "),
                  _c("header-signature", {
                    attrs: { text: _vm.essentialTitle },
                  }),
                  _vm._v(" "),
                  _vm.currentVersion.zigZag
                    ? _c("EditorialPush", {
                        attrs: { zigzag: _vm.currentVersion.zigZag },
                      })
                    : _vm.currentVersion.longDescription
                    ? _c("div", [
                        _c("p", {
                          attrs: { id: "anchor-zig-zag" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.currentVersion.longDescription
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.technicalFeatures
            ? _c(
                "section",
                [
                  _vm.currentVersion.zigZag ||
                  _vm.currentVersion.longDescription
                    ? _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("device-technical-features", {
                    attrs: {
                      "device-features": _vm.currentVersion.technicalFeatures,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRecovery
            ? [
                _c(
                  "section",
                  { staticClass: "mb-2 mb-md-3" },
                  [
                    _c("ob1-separateur", { staticClass: "my-2" }),
                    _vm._v(" "),
                    _c("header-signature", {
                      attrs: { text: _vm.recoveryMessages.messages.title },
                    }),
                    _vm._v(" "),
                    _c("mobile-recovery", {
                      attrs: {
                        id: "anchor-mobile-recovery",
                        "recovery-amount-in-cents":
                          _vm.advantages.recovery.amountInCents,
                        "recovery-device-model":
                          _vm.advantages.recovery.deviceModel,
                        "manual-estimation":
                          _vm.advantages.recovery.manualEstimation,
                        "bonus-amount-in-cents": _vm.bonusAmountInCents,
                        "simulator-modal-id": _vm.simulatorModalId,
                        "recovery-modal-id": _vm.recoveryModalId,
                        messages: _vm.recoveryMessages.messages,
                        visual: _vm.recoveryMessages.visual,
                        shop: _vm.shop,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.showGuaranteeLegalMentions
            ? _c(
                "section",
                [
                  _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                  _vm._v(" "),
                  _c("guarantee-legal-mentions", {
                    attrs: {
                      "legal-mentions": _vm.currentVersion.deviceLegalMentions,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.ecoRating
            ? _c(
                "section",
                [
                  _c("eco-rating", {
                    attrs: { "eco-rating": _vm.currentVersion.ecoRating },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.retailMention
            ? _c(
                "section",
                [
                  _c("ob1-separateur", { staticClass: "my-2 mb-xl-3" }),
                  _vm._v(" "),
                  _c("header-signature", {
                    attrs: { text: _vm.dto.retailMentionTitle },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      attrs: { id: "anchor-reconditioned" },
                    },
                    [
                      _c("div", { staticClass: "col-12 mb-1" }, [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.retailMention) },
                        }),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displayRatings
            ? [
                _c(
                  "section",
                  { staticClass: "mb-md-3" },
                  [
                    _vm.currentVersion.showGuaranteeLegalMentions
                      ? _c("ob1-separateur", { staticClass: "my-2" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("header-signature", {
                      attrs: { text: _vm.reviewsMessages.title },
                    }),
                    _vm._v(" "),
                    _c("device-average-rating-reviews", {
                      attrs: {
                        "reviews-stats-average":
                          _vm.currentVersion.reviewsStats.average,
                        "review-count": _vm.currentVersion.reviewsStats.count,
                        "reviews-messages": _vm.reviewsMessages,
                        summary: _vm.currentVersion.summary,
                      },
                    }),
                    _vm._v(" "),
                    _c("device-filter-and-details-reviews", {
                      attrs: {
                        "device-details-reviews": _vm.deviceDetailsReviews,
                        "total-review-count":
                          _vm.currentVersion.reviewsStats.count,
                        "device-filter-reviews": _vm.deviceFilterReviews,
                        "reviews-messages": _vm.reviewsMessages,
                        "ratings-filter-checkboxes":
                          _vm.ratingsFilterCheckboxes,
                        "date-sort-radio-buttons": _vm.dateSortRadioButtons,
                      },
                      on: {
                        "update-ratings-filter-handler":
                          _vm.updateRatingsFilterHandler,
                        "review-date-sort-item-click":
                          _vm.reviewDateSortHandler,
                        "more-device-reviews": _vm.getMoreDeviceReviews,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentVersion.environmentalQuality
            ? _c("ob1-liens", {
                staticClass: "mw-100 py-0",
                attrs: {
                  href: _vm.currentVersion.environmentalQuality.url,
                  text: _vm.currentVersion.environmentalQuality.linkLabel,
                  "with-arrow": true,
                  "is-mini": true,
                  target: "_blank",
                },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.dto.freeHandsText || _vm.shouldDisplay4xCBMention
        ? _c("div", { staticClass: "bg-gray2 mt-1 pt-1 pb-1" }, [
            _c(
              "div",
              { staticClass: "container-fluid" },
              [
                _c("free-hands", { attrs: { text: _vm.dto.freeHandsText } }),
                _vm._v(" "),
                _vm.shouldDisplay4xCBMention
                  ? _c("legal-mentions4x-cb", {
                      attrs: {
                        label: _vm.dto.cb4xMention.label,
                        "popin4x-cb": _vm.dto.cb4xMention.cb4xPopin,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentVersion.firstParty
        ? _c("section", [
            _vm.isBrandSosh
              ? _c(
                  "div",
                  { staticClass: "container-fluid" },
                  [
                    _c("sosh-commitments", {
                      attrs: { commitments: _vm.dto.soshCommitments },
                    }),
                  ],
                  1
                )
              : _c("div", { staticClass: "bg-dark d-webview-none" }, [
                  _c(
                    "div",
                    { staticClass: "container-fluid" },
                    [
                      _c("orange-commitments", {
                        attrs: { commitments: _vm.dto.orangeCommitments },
                      }),
                    ],
                    1
                  ),
                ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "savedSimulationSnackbar",
        attrs: {
          id: "simulation-snackbar",
          icon: "icon-tick-circle",
          label: _vm.dto.refundMessages.recoverySimulator.result.snackbarLabel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "col-12 mb-sm-0" }, [
      _c("strong", [_vm._v("En précommande en ligne")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }